module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "web-viewer"
  }, [_c('div', {
    staticClass: "doc-container"
  }, [_c('div', {
    ref: "viewer",
    staticClass: "doc-viewer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "doc-analyses"
  }, [_c('tabs', {
    ref: "tabs",
    attrs: {
      "options": {
        useUrlFragment: false
      },
      "cache-lifetime": "0"
    },
    on: {
      "changed": _vm.onTabChanged
    }
  }, [_c('tab', {
    attrs: {
      "name": "Fields"
    }
  }, [(_vm.data != null) ? _c('div', {
    staticClass: "fields"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("DocType: "), _c('b', [_vm._v(_vm._s(_vm.docType))])]), _vm._v(" "), (_vm.parties.length > 0) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "cursor-pointer",
    class: {
      'margin-bottom-10': _vm.openParties
    },
    on: {
      "click": function($event) {
        _vm.openParties = !_vm.openParties
      }
    }
  }, [_c('span', {
    staticClass: "field-color-indicator",
    style: ({
      backgroundColor: _vm.data.fields.Parties.color
    })
  }), _vm._v("\n                                Parties (" + _vm._s(_vm.parties.length) + ")\n                                "), (!_vm.openParties) ? _c('i', {
    staticClass: "icon-caret-down pull-right"
  }) : _vm._e(), _vm._v(" "), (_vm.openParties) ? _c('i', {
    staticClass: "icon-caret-up pull-right"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.parties), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openParties),
        expression: "openParties"
      }],
      key: key,
      staticClass: "list-group-item"
    }, _vm._l((item.valueObject), function(val, fieldName) {
      return _c('div', {
        key: fieldName,
        staticClass: "margin-top-10"
      }, [_c('p', {
        staticClass: "secondary-text"
      }, [_vm._v(_vm._s(fieldName))]), _vm._v(" "), _c('p', {
        staticClass: "field-content",
        on: {
          "mouseover": function($event) {
            return _vm.setHighlights(val.boundingRegions)
          },
          "mouseleave": function($event) {
            return _vm.removeHighlights(val.boundingRegions)
          }
        }
      }, [_c('b', [_vm._v(_vm._s(val.content))])]), _vm._v(" "), (val.type != 'string') ? _c('div', {
        staticClass: "padding-15"
      }, _vm._l((val.valueAddress), function(value, name) {
        return _c('li', {
          key: name,
          staticClass: "padding-bottom-10 list-unstyled"
        }, [_c('p', {
          staticClass: "margin-bottom-5 text-capitalize secondary-text"
        }, [_vm._v(_vm._s(name))]), _vm._v(" "), _c('p', {
          staticClass: "field-content",
          on: {
            "mouseover": function($event) {
              return _vm.setHighlights(val.boundingRegions)
            },
            "mouseleave": function($event) {
              return _vm.removeHighlights(val.boundingRegions)
            }
          }
        }, [_c('b', [_vm._v(_vm._s(value))])])])
      }), 0) : _vm._e()])
    }), 0)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.jurisdictions.length > 0) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "cursor-pointer",
    class: {
      'margin-bottom-10': _vm.openJurisdictions
    },
    on: {
      "click": function($event) {
        _vm.openJurisdictions = !_vm.openJurisdictions
      }
    }
  }, [_c('span', {
    staticClass: "field-color-indicator",
    style: ({
      backgroundColor: _vm.data.fields.Jurisdictions.color
    })
  }), _vm._v("\n                                Jurisdictions (" + _vm._s(_vm.jurisdictions.length) + ")\n                                "), (!_vm.openJurisdictions) ? _c('i', {
    staticClass: "icon-caret-down pull-right"
  }) : _vm._e(), _vm._v(" "), (_vm.openJurisdictions) ? _c('i', {
    staticClass: "icon-caret-up pull-right"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.jurisdictions), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openJurisdictions),
        expression: "openJurisdictions"
      }],
      key: key,
      staticClass: "list-group-item"
    }, _vm._l((item.valueObject), function(val, fieldName) {
      return _c('div', {
        key: fieldName,
        staticClass: "margin-top-10"
      }, [_c('p', {
        staticClass: "secondary-text"
      }, [_vm._v(_vm._s(fieldName))]), _vm._v(" "), _c('p', {
        staticClass: "field-content",
        on: {
          "mouseover": function($event) {
            return _vm.setHighlights(val.boundingRegions)
          },
          "mouseleave": function($event) {
            return _vm.removeHighlights(val.boundingRegions)
          }
        }
      }, [_c('b', [_vm._v(_vm._s(val.content))])])])
    }), 0)
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.fields), function(value, key) {
    return _c('li', {
      key: key,
      staticClass: "list-group-item"
    }, [(value.type != 'array') ? _c('div', [_c('p', {
      staticClass: "text-left"
    }, [_c('span', {
      staticClass: "field-color-indicator",
      style: ({
        backgroundColor: value.color
      })
    }), _vm._v("\n                                    " + _vm._s(key) + "\n                                    "), _vm._l((value.boundingRegions), function(data, index) {
      return _c('span', {
        key: index,
        staticClass: "badge"
      }, [_vm._v("\n                                        #\n                                        " + _vm._s(data.pageNumber) + "\n                                    ")])
    }), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(value.confidence))])], 2), _vm._v(" "), _c('p', {
      staticClass: "field-content padding-left-20",
      on: {
        "mouseover": function($event) {
          return _vm.setHighlights(value.boundingRegions)
        },
        "mouseleave": function($event) {
          return _vm.removeHighlights(value.boundingRegions)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(value.content))])])]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.data === null) ? _c('div', {
    staticClass: "text-center center-div"
  }, [_c('h4', [_vm._v("Run anaysis on this document to see the results")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.file == null
    },
    on: {
      "click": _vm.runAnalysis
    }
  }, [_vm._v("Run analysis")])]) : _vm._e()]), _vm._v(" "), _c('tab', {
    staticClass: "padding-20",
    attrs: {
      "name": "Content"
    }
  }, [_vm._l((_vm.paragraphs), function(item, key) {
    return (_vm.pdfData != null) ? _c('div', {
      key: key,
      staticClass: "card",
      on: {
        "mouseover": function($event) {
          return _vm.setHighlights(item.boundingRegions)
        },
        "mouseleave": function($event) {
          return _vm.removeHighlights(item.boundingRegions)
        }
      }
    }, [_c('div', {
      staticClass: "card-title text-capitalize"
    }, [_vm._v(" " + _vm._s(item.role ? item.role : 'Paragraph'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.content))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pdfData === null) ? _c('div', {
    staticClass: "text-center center-div"
  }, [_c('h4', [_vm._v("Run anaysis on this document to see the results")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.file == null
    },
    on: {
      "click": _vm.runAnalysis
    }
  }, [_vm._v("Run analysis")])]) : _vm._e()], 2), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Result"
    }
  }, [(_vm.pdfData != null) ? _c('json-viewer', {
    attrs: {
      "value": _vm.pdfData,
      "copyable": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pdfData === null) ? _c('div', {
    staticClass: "text-center center-div"
  }, [_c('h4', [_vm._v("Run anaysis on this document to see the results")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.file == null
    },
    on: {
      "click": _vm.runAnalysis
    }
  }, [_vm._v("Run analysis")])]) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bfae3738", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-bfae3738!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Scripts/components/WebViewer.vue
// module id = 42
// module chunks = 1